<template>
    <LoadingState :loading="loading" />
    <div>
        <div class="flex justify-between items-center mb-8 mt-3">
            <div class="">
                <h1 class="text-2xl font-semibold text-primary">My Points</h1>
            </div>

            <div
                class="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2"
            >
                <button
                    @click="setProgramModal(true)"
                    class="btn-base !mt-0 !px-4 flex items-center gap-2 bg-orange hover:bg-orange-600 text-white rounded-md"
                    id="hs-mypoints-add-program"
                >
                    <Icon icon="plus" pathClass="stroke-white" />
                    Add Program
                </button>
            </div>
        </div>

        <UserRewards
            v-for="(user, i) in rewards?.users || []"
            :user="user"
            :key="'user-' + i"
            @editProgram="editProgram"
            @deleteProgram="deleteProgram"
        />

        <!--
        TODO: MY1-836 add hide/show banner feature from backend
        <award-booking-program-card></award-booking-program-card>
-->

        <AddReward />

        <ProgramOptionsModal />

        <BulkUpdateBalances />

        <PointsSidebar />
    </div>
</template>
<script>
import { mapState, mapActions } from 'pinia';
import { usePointsStore } from '@/store/points';

import vClickOutside from 'click-outside-vue3';
import UserRewards from '@/components/mypoints/user-rewards.vue';
import AddReward from '@/components/mypoints/modals/add-reward.vue';
import ProgramOptionsModal from '@/components/mypoints/modals/program-options.vue';
import BulkUpdateBalances from '@/components/mypoints/modals/bulk-update-balances.vue';
import PointsSidebar from '@/components/mypoints/points-sidebar.vue';
import AwardBookingProgramCard from '@/components/mypoints/award-booking-program-card.vue';
import LoadingState from '@/components/ui/loading-state/loading-state.vue';
import Icon from '@/components/ui/icon/icon.vue';

export default {
    components: {
        UserRewards,
        AddReward,
        ProgramOptionsModal,
        BulkUpdateBalances,
        PointsSidebar,
        AwardBookingProgramCard,
        LoadingState,
        Icon,
    },
    directives: {
        ClickOutside: vClickOutside.directive,
    },
    props: {},
    data: () => ({
        errors: [],
    }),
    watch: {},
    computed: {
        ...mapState(usePointsStore, [
            'loading',
            'rewards',
            'programs',
            'reward',
            'user',
            'addRewardUser',
            'showProgramModal',
            'showEditProgramModal',
        ]),
    },
    methods: {
        ...mapActions(usePointsStore, [
            'getRewards',
            'deleteProgram',
            'editProgram',
            'setProgramModal',
            'setEditProgramModal',
            'showProgramModalAction',
            'openBulkUpdateModal',
        ]),
        applyDeepLinkParams() {
            const params = new URLSearchParams(window.location.search);
            const userId = params.get('user_id');
            const action = params.get('action');

            if (action === 'update-balances') {
                this.openBulkUpdateModal(userId);
            }

            if (userId || action) {
                history.replaceState(
                    {},
                    document.title,
                    window.location.pathname
                );
            }
        },
    },
    created() {},
    mounted() {
        this.getRewards().then(() => {
            this.applyDeepLinkParams();
        });
    },
};
</script>
<style lang="scss" scoped>
.fadeInOut-enter-active,
.fadeInOut-leave-active {
    transition: opacity 0.8s;
    opacity: 1;
}
.fadeInOut-enter,
.fadeInOut-leave-to {
    opacity: 0;
}
</style>
